import { createFileRoute } from "@tanstack/react-router";

import { EmailVerificationRouteComponent } from "@/route-components/EmailVerificationRouteComponent";

import { requireAuth } from "../../utils/routeGuards";

export const Route = createFileRoute("/auth/email-verification")({
  beforeLoad: ({ location }) => requireAuth(location),
  validateSearch: (search: Record<string, unknown>) => {
    return {
      email: search.email as string | undefined,
    };
  },
  component: EmailVerificationRouteComponent,
});
